import React from 'react';

import Select from 'react-select';

const options = [
  {
    label: 'Manager',
    value: true,
  },
  {
    label: 'Team Member',
    value: false,
  },
];

/**
 * @deprecated 8-04-2025
 */
export default function CheckInSelect({ onChange, defaultValue = false, ...props }) {
  return (
    <Select
      classNamePrefix="react-select"
      label="Single select"
      options={options}
      isSearchable={false}
      onChange={(selectedOption) => onChange(selectedOption.value)}
      styles={colourStyles}
      defaultValue={options.filter(({ value }) => value === defaultValue)[0]}
      theme={(theme, data) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: 'lightGrey',
        },
      })}
      {...props}
    />
  );
}

const colourStyles = {
  dropdownIndicator: (styles, data) => ({
    ...styles,
    color: 'transparent',
    padding: '4px',
  }),
  indicatorSeparator: (styles, data) => ({
    ...styles,
    backgroundColor: 'transparent',
  }),
  control: (styles, data) => {
    const color = '#ccc';
    return {
      ...styles,
      backgroundColor: 'transparent',
      fontSize: '14px',
      color: '#999',

      width: '16ch',
      minHeight: '30px',
      boxShadow: 'none',
      borderColor: 'transparent',
      ':hover': {
        ...styles[':hover'],
        borderColor: color,
        backgroundColor: 'white',
        cursor: 'pointer',

        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
      ':focus': {
        ...styles[':focus'],
        borderColor: color,
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
      ':active': {
        ...styles[':active'],
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
    };
  },

  input: (styles, state) => styles,
  singleValue: (styles, { data }) => ({ ...styles, color: data.color }),
};
